/*
 * @Author: wsx
 * @Date: 2022-01-19 16:25:49
 * @LastEditTime: 2022-02-14 15:47:54
 * @LastEditors: Please set LastEditors
 * @Description:
 */

import request from "@/utils/request.js";

// 获取角色列表
export const getRoleList = data => {
  return request({
    url: "/api/hz-smart-community/sys/role/list",
    params: data || {}
  });
};
// 获取角色选项列表
export const getRoleSelect = data => {
  return request({
    url: "/api/hz-smart-community/sys/role/select",
    params: data || {}
  });
};
// 角色信息
export const getRoleInfo = data => {
  return request({
    url: "/api/hz-smart-community/sys/role/info/" + data
  });
};
// 添加角色
export const roleSave = data => {
  return request({
    url: "/api/hz-smart-community/sys/role/save",
    data: data || {},
    method: "POST"
  });
};

// 更新角色
export const roleUpdate = data => {
  return request({
    url: "/api/hz-smart-community/sys/role/update",
    data: data || {},
    method: "POST"
  });
};

// 删除角色
export const roleDelete = data => {
  return request({
    url: "/api/hz-smart-community/sys/role/delete",
    data: data || {},
    method: "POST"
  });
};
